import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#1C1635] group-[.toaster]:text-white group-[.toaster]:border group-[.toaster]:border-[#632CA6]/30 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-gray-400",
          actionButton:
            "group-[.toast]:bg-[#632CA6] group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-[#1C1635] group-[.toast]:text-gray-300",
          success: "group-[.toast]:bg-[#00C9B7]/10 group-[.toast]:border-[#00C9B7]/50",
          error: "group-[.toast]:bg-red-500/10 group-[.toast]:border-red-500/50",
        },
      }}
      {...props} />
  );
}

export { Toaster }
